import { Store } from "../store/Store.js";
export const asyncResourceStore = new Store();
